import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from '../../i18n';

// No UI — mounted once near the root. Whenever a signed-in user's Firestore
// profile carries a saved `language`, it wins over whatever localStorage/
// browser-detection picked at boot (e.g. this browser was last used by a
// different staff member, or the account's preference was set on another
// device).
export default function LanguageSync() {
  const { userProfile } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    const preferred = userProfile?.language;
    if (preferred && SUPPORTED_LANGUAGES.includes(preferred) && preferred !== i18n.language) {
      i18n.changeLanguage(preferred);
      try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, preferred);
      } catch {
        // localStorage unavailable — in-memory language change still applies
      }
    }
  }, [userProfile, i18n]);

  return null;
}
